<style lang="scss" scoped>
.fl{
  float: left;
}
.fr{
  float: right;
}
.cursor-p{
  cursor: pointer;
}
  footer{
    background: #464646;
    padding:50px 0 20px;
    color:#fff;
    margin-top: 50px;
    .ul1{
      border-bottom: 2px solid #fff;
      dt{
        font-size: 18px;
        dd{
          a{
            font-size: 16px;
          }
        }
      }

    }
    .ul2{
      margin-top: 20px;
      margin-bottom: 10px;
      overflow: auto;
      padding-bottom: 20px;
      border-bottom: 2px solid #fff;
      li:nth-last-child(1){
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        padding-right: 0px!important;
      }
      li:nth-last-child(2){
        width: 30%;
      }
      li:nth-last-child(3){
        width: 40%;
      }
      li{
        float: left;
        border-right: 1px dashed #fff;
        padding-right: 30px;
        padding-left: 30px;
      }
      li:first-child{
        padding-left: 0;
      }
      li:last-child{
        padding-right: 0;
        border-right: none;
      }

      .logo{
        width: 188px;
        margin-bottom: 15px;
      }

      .foot_left{
        width: 65%;
        .xinxi{
          overflow: auto;
          margin-bottom: 20px;
          .img{
            width: 31px;
            margin-right: 10px;
          }
          .con{
            margin-top: 10px;
          }
          .con1{
            margin-top: 5px;
          }
          .con2{
            overflow: auto;
            margin-top: 2px;
            width: 200px;
          }
        }
        .xinxi:last-child{
          margin-bottom: 0;
        }
      }
      .foot_left1{
        width: 100% !important;
      }
    }
    &.pt90{
      padding-top: 30px;
    }
    .logo{
      width:125px;
    }
    .ul1{
      display: flex;
      justify-content: space-around;
      padding:40px 0;
      width:100%;
    }
    //.ul1 li:nth-child(2){
    //  margin-top: -20px;
    //}

    dt{
      font-size: 16px;
      color:#fff;
      padding-bottom: 10px;
      font-weight: 500;
      a{
        color:#fff;
      }
    }
    dd{
      margin-top: 10px;
      a{
        color:#fff;
      }
    }

    .copyright{
      font-size: 12px;
      display: flex;
      padding-top: 20px;
      align-items: center;
      justify-content: center;
      span{
        margin:0 5px;
      }
      img{
        width:14px;
        margin-left: 5px;
      }
    }
    .cons,.copy{
      display: none;
    }
  }
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .cons .copyright{
    display: block!important;
  }
  .cop{
    display:block!important;
  }
  .copy{
    display: none!important;
  }
  footer{
    padding: 0 0 20px!important;
    margin-top: 0!important;
  }
  .pt90{
    padding-top: 0!important;
  }
  .con{
    display: none!important;
  }
}
@media screen and (max-width: 640px) and (min-width: 600px){
  .cons{
    display: block!important;
  }
  .cons .copyright{
    display: block!important;
  }
  footer{
    padding: 0 0 20px!important;
    margin-top: 0!important;
  }
  .pt90{
    padding-top: 0!important;
  }
  .con{
    display: none!important;
  }
  .copy{
    display:block!important;
  }
  .cop{
    display: none!important;
  }
}
  @media screen and (max-width: 640px){
    .container ul{
      display: none;
    }
    .container{
      width: 90% !important;
      font-size: 14px!important;
    }
    .container .copyright{
      text-align: center;
    }
    .container .copyright span{
      display: block!important;
      margin-bottom: 10px;
    }
    .container .copyright span:last-child{
      margin-bottom: 0;
    }
    .gong_an{
      margin-bottom: 10px;
      overflow:auto;
      margin-left: auto;
      margin-right: auto;
      width: -moz-fit-content;
      width: fit-content;
    }
    .gong_an img{
      margin-right: 5px;
    }
  }
</style>
<template>

  <footer :class="{pt90: largeTop}" >
    <div class="container con">
      <ul class="ul1">
        <li v-for="(item, index) in pageData.footer" :key="index">
          <dl>
            <dt>
<!--              {{item.title}}-->
              <span class="cursor-p" @click="jumps(item.to, item.title)" v-if="item.to === '/products'">{{item.title}}</span>
              <span class="cursor-p" @click="jumps(item.to)" v-else-if="item.to || item.to === ''">{{item.title}}</span>
              <span v-else style="color: #333">{{item.title}}</span>
            </dt>
               <dd v-for="(itx, idx) in item.children" :key="idx">
               <span class="cursor-p" @click="jumps(itx.to, itx.title)" v-if="itx.to === '/products'">{{itx.name}}</span>
               <span class="cursor-p" @click="jumps(itx.to)" v-else-if="itx.to || itx.to === ''">{{itx.name}}</span>
               <span v-else>{{itx.name}}</span>
               </dd>
            <div v-if="item.title === '资源中心'" :style="{marginTop: '20px'}">
              <div class="flex flex-justify-start">
                <img src="@/assets/img/iso/1.png" style="cursor: pointer; width: 60px">
                <img src="@/assets/img/iso/2.png" style="cursor: pointer; width: 60px">
              </div>
            </div>
          </dl>
        </li>
      </ul>
      <ul class="ul2">
        <li>
          <div class="logo"><img src="@/assets/img/qk.png" style="cursor: pointer" @click="shop1"></div>
          <div style="overflow:auto;">
            <div class="foot_left fl">
              <div class="xinxi">
                <div class="img fl"><img src="@/assets/img/ipone.png"></div>
                <div class="con fl">400-668-3730</div>
              </div>
              <div class="xinxi">
                <div class="img fl"><img src="@/assets/img/email.png"></div>
                <div class="con1 fl">market@tsingke.com.cn</div>
              </div>
              <div class="xinxi">
                <div class="img fl"><img src="@/assets/img/adress.png"></div>
                <div class="con2 fl">北京市北京经济技术开发区经海三路105号院3号楼西半单元</div>
              </div>
            </div>
            <div class="foot_right fr">
              <div class="fot_top" style="margin-bottom: 5px;"><img src="@/assets/img/lx.png" width="100%"></div>
              <div class="img" style="width: 120px;"><img src="@/assets/img/qrcode.png" width="100%"></div>
            </div>
          </div>
        </li>
        <li>
          <div class="logo"><img src="@/assets/img/zixi.png" style="cursor: pointer"></div>
          <div class="foot_left foot_left1 fl">
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/ipone.png"></div>
              <div class="con fl">010-61734100</div>
            </div>
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/email.png"></div>
              <div class="con1 fl">oligo@tsingke.com.cn</div>
            </div>
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/adress.png"></div>
              <div class="con2">北京市北京经济技术开发区经海三路105号院3号楼西半单元</div>
            </div>
          </div>
        </li>
        <li>
          <div class="logo"><img src="@/assets/img/dina.png" width="100%" @click="shop" style="cursor: pointer"></div>
          <div class="foot_left foot_left1 fl">
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/ipone.png"></div>
              <div class="con fl">0317-7581236</div>
            </div>
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/email.png"></div>
              <div class="con1 fl">sale@dnachem.com</div>
            </div>
            <div class="xinxi">
              <div class="img fl"><img src="@/assets/img/adress.png"></div>
              <div class="con2">河北省沧州市临港经济开发区西区经二路北侧迪纳兴科</div>
            </div>
          </div>
        </li>
      </ul>
<!--      <ul>-->
<!--        <li><img src="@/assets/images/logo.png" class="logo"> </li>-->
<!--        <li v-for="(item, index) in pageData.footer" :key="index">-->
<!--          <dl>-->
<!--            <dt>{{item.title}}</dt>-->
<!--            <dd v-for="(itx, idx) in item.children" :key="idx">-->
<!--              <router-link :to="`${itx.to}?name=${itx.name}`" v-if="itx.to === '/products'">{{itx.name}}</router-link>-->
<!--              <router-link :to="itx.to" v-else-if="itx.to || itx.to === ''">{{itx.name}}</router-link>-->
<!--              <span v-else>{{itx.name}}</span>-->
<!--            </dd>-->
<!--            <img src="@/assets/images/qrcode.png" v-show="item.title === '联系我们'" class="mt20">-->
<!--          </dl>-->
<!--        </li>-->
<!--      </ul>-->
      <div class="copyright">
<!--        © 2009-2019 Aliyun.com 版权所有 ICP证：浙B2-20080101<br>-->
<!--        京公网安备 11030102010743号-->

        <span>@2020-2024 版权所有.</span>|<span @click="viewLicence" :style="{cursor: 'pointer'}">营业执照</span>|<span><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">京ICP备19006399号-3</a></span>|<img src="@/assets/images/copy.png"><span style="width: 173px"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010743" style="text-decoration:none"><img src="" style="float:left;"/><p style="float:left;margin: 0px 0px 0px 5px; color:#fff;">京公网安备 11030102010743号</p></a></span>|<span>本网站所有信息仅针对中国地区客户，销售的所有产品和服务仅供研究使用，不用于临床诊断</span>
      </div>
    </div>

    <div class="container cons">

      <!--      <ul>-->
      <!--        <li><img src="@/assets/images/logo.png" class="logo"> </li>-->
      <!--        <li v-for="(item, index) in pageData.footer" :key="index">-->
      <!--          <dl>-->
      <!--            <dt>{{item.title}}</dt>-->
      <!--            <dd v-for="(itx, idx) in item.children" :key="idx">-->
      <!--              <router-link :to="`${itx.to}?name=${itx.name}`" v-if="itx.to === '/products'">{{itx.name}}</router-link>-->
      <!--              <router-link :to="itx.to" v-else-if="itx.to || itx.to === ''">{{itx.name}}</router-link>-->
      <!--              <span v-else>{{itx.name}}</span>-->
      <!--            </dd>-->
      <!--            <img src="@/assets/images/qrcode.png" v-show="item.title === '联系我们'" class="mt20">-->
      <!--          </dl>-->
      <!--        </li>-->
      <!--      </ul>-->
      <div class="copyright">
        <!--        © 2009-2019 Aliyun.com 版权所有 ICP证：浙B2-20080101<br>-->
        <!--        京公网安备 11030102010743号-->
        <div class="cop">
          <span>@2020-2024 版权所有</span><span @click="viewLicence" :style="{cursor: 'pointer'}">营业执照</span><span style="float: left;margin-left: 30%;"><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">京ICP备19006399号-3</a></span><img src="@/assets/images/copy.png" style="margin-left: -28%;"><span><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010743" style="text-decoration:none;"><img src="" style="float:left;"/><p style="float:left;margin: 0px 0px 0px 5px; color:#fff;">京公网安备 11030102010743号</p></a></span><span>本网站所有信息仅针对中国地区客户，销售的所有产品和服务仅供研究使用，不用于临床诊断</span>
        </div>
        <div class="copy" style="font-size: 14px">
          <div style="margin-bottom: 10px;">@2020-2023 版权所有  营业执照</div>
          <div style="margin-bottom: 10px;"><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">京ICP备19006399号-3</a><img src="@/assets/images/copy.png"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010743" style="text-decoration:none"><img src="" style="float:left;"/><p class="ying1" style="float:left;margin: 3px 0px 0px 5px; color:#fff;">京公网安备 11030102010743号</p></a></div>
          <div>本网站所有信息仅针对中国地区客户，销售的所有产品和服务仅供研究使用，不用于临床诊断</div>
        </div>
      </div>

    </div>
    <el-dialog
      title="营业执照"
      :visible.sync="licenceShow"
    >
      <img src="@/assets/img/business-license.jpg" style="cursor: pointer; width: 100%"  oncontextmenu="return false">
    </el-dialog>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'qk-footer',
  data () {
    return {
      largeTop: false,
      licenceShow: false
    }
  },
  computed: {
    ...mapState(['pageData'])
  },
  created () {
    this.setPadTop(this.$route.path)
  },
  methods: {
    viewLicence() {
      this.licenceShow = true
    },

    jumps(path, name) {
      console.log(path)
      if(path.indexOf('https://')>-1){
         window.location.href = path
      }else{
        this.$router.push({ path, params: {name} })
      }
      
      // 适应新需求，只需要footer中点击scrollTop为0
      window.scrollTo(0, 0)
    },
    setPadTop (path) {
      let paths = ['/', '/tec/gen_compose', '/sanger', '/tec/compose', '/sanger', '/tec/compose1', '/tec/compose2', '/tec/compose3']
      this.largeTop = paths.includes(path)
    },
    //跳转商城
    shop(){
      let href = "http://www.dnachem.com/";
      window.open(href, "_blank");
    },
    //跳转商城
    shop1(){
      let href = "https://tsingke.com.cn/";
      window.open(href, "_blank");
    },
  },
  watch: {
    $route (to) {
      this.setPadTop(to.path)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue